import { callAPI } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function getMemberType(data: any) {
    const url = `${PATH_API}/member-type/filtered`;
    return await callAPI({
        url,
        method: "POST",
        data: data
    });
}

